<template>
  <div class="animated fadeIn" v-if="show">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        일정 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">일정</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <div class="d-flex flex-wrap align-items-center">
      <b-col>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7 text-danger">
            * Notice : 사이트의 원활한 이용을 위해 하루에 최대 3번 점검이 가능합니다.
          </div>
        </b-input-group>
      </b-col>
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || 'Search'" v-model="so.sk" @change="sv_reset">
              <option disabled value="">검색</option>
              <option value="group.groupname">그룹</option>
              <option value="site.fqdn">FQDN</option>
              <option value="site.name">이름</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input class="form-control col-xl-12" :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mb7" v-b-tooltip.hover title="can see the log real-time">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15"> 표시되는 개수 : 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
            :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="group" slot-scope="row">{{row.item.group ? row.item.group.groupname : '-'}}</template>
            <template slot="fqdn" slot-scope="row">{{row.item.site.fqdn}}</template>
            <template slot="name" slot-scope="row">
              <del v-if="row.item.site.is_del">{{row.item.site.name}}</del>
              <template v-else>{{row.item.site.name}}</template>
            </template>
            <template slot="last_time" slot-scope="row">{{row.item.last_time | utcdatetime}}</template>
            <template slot="due_time" slot-scope="row">{{row.item.due_time | utcdatetime }}</template>
            <template slot="func" slot-scope="row">
              <b-btn :disabled="row.item.is_starting" @click="action('delay', row.item)" size="sm" variant="outline-warning" tabindex="4">지연</b-btn>
              <b-btn :disabled="row.item.is_starting" @click="action('start', row.item)" size="sm" variant="outline-danger" tabindex="4">시작</b-btn>
              <b-btn @click="action('result', row.item)" size="sm" variant="outline-primary" tabindex="4">최근 결과</b-btn>
              <b-btn @click="action('site', row.item)" size="sm" variant="outline-success" tabindex="4">사이트</b-btn>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :limit="10" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>